var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "warning-bi", class: _vm.type }, [
    _c(
      "div",
      { staticClass: "d-flex align-items-center", staticStyle: { flex: "1" } },
      [
        _c("icon-svg", {
          attrs: {
            name: _vm.warning[_vm.type].icon,
            color: _vm.warning[_vm.type].color,
            size: "40"
          }
        }),
        _c(
          "div",
          { staticClass: "text", staticStyle: { "margin-left": "19px" } },
          [_vm._t("description")],
          2
        )
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "warning-actions" },
      [
        _vm._t("button"),
        _vm.close
          ? _c(
              "v-btn",
              {
                attrs: { icon: "" },
                on: {
                  click: function($event) {
                    return _vm.$emit("close")
                  }
                }
              },
              [
                _c("icon-svg", {
                  attrs: { name: "close-circle", color: "#8E8E8E", size: "24" }
                })
              ],
              1
            )
          : _vm._e()
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }